import React from 'react';
import {
  Box,
  Typography,
  Button,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { UserProfile } from '../../services/supabaseService';
import { useUserType } from '../../contexts/UserTypeContext';

interface ProfileSectionProps {
  profile: UserProfile | null;
}

export const ProfileSection: React.FC<ProfileSectionProps> = ({
  profile,
}) => {
  const navigate = useNavigate();
  const { currentType, switchType } = useUserType();
  const isReviewer = currentType === 'reviewer';

  const handleEditProfile = () => {
    if (isReviewer) {
      navigate('/mypage/reviewer/edit-profile');
    } else {
      navigate('/mypage/advertiser/edit-profile');
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {/* 상단: 사용자 타입과 프로필 수정 버튼 */}
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Typography sx={{ 
            fontSize: '0.875rem', 
            color: 'rgba(255, 255, 255, 0.7)'
          }}>
            {isReviewer ? '리뷰어' : '광고주'}
          </Typography>
          <Button
            variant="text"
            size="small"
            onClick={handleEditProfile}
            sx={{
              color: 'rgba(255, 255, 255, 0.7)',
              fontSize: '0.75rem',
              padding: '2px 0',
              minWidth: 'auto',
              '&:hover': {
                background: 'none',
                color: 'white'
              }
            }}
          >
            프로필 수정
          </Button>
        </Box>
        <Button
          variant="outlined"
          size="small"
          onClick={switchType}
          sx={{
            color: 'white',
            borderColor: 'rgba(255, 255, 255, 0.5)',
            fontSize: '0.875rem',
            height: '32px',
            minWidth: '100px',
            '&:hover': {
              borderColor: 'white',
              background: 'rgba(255, 255, 255, 0.1)'
            }
          }}
        >
          {isReviewer ? '광고주 전환' : '리뷰어 전환'}
        </Button>
      </Box>

      {/* 중단: 사용자 이름 */}
      <Typography sx={{ 
        fontWeight: 500,
        fontSize: '1.125rem',
        lineHeight: 1.2,
        mb: 1
      }}>
        {profile?.displayName || '알수없음'}
      </Typography>

      {/* 하단: 포인트와 별점 */}
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: 4
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography 
            component="span" 
            sx={{ 
              fontSize: '0.875rem',
              color: 'rgba(255, 255, 255, 0.7)',
              whiteSpace: 'nowrap'
            }}
          >
            보유 포인트
          </Typography>
          <Typography 
            component="span" 
            sx={{ 
              fontSize: '1rem',
              fontWeight: 500
            }}
          >
            0P
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography 
            component="span" 
            sx={{ 
              fontSize: '0.875rem',
              color: 'rgba(255, 255, 255, 0.7)',
              whiteSpace: 'nowrap'
            }}
          >
            나의 별점
          </Typography>
          <Typography 
            component="span" 
            sx={{ 
              fontSize: '1rem',
              fontWeight: 500
            }}
          >
            0
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}; 